"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.enums = void 0;
const ClassVacancySubscription_1 = require("./ClassVacancySubscription");
var Type;
(function (Type) {
    Type["THREE_MONTHS"] = "THREE_MONTHS";
    Type["SIX_MONTHS"] = "SIX_MONTHS";
    Type["TWELVE_MONTHS"] = "TWELVE_MONTHS";
    Type["ONE_MONTHS"] = "ONE_MONTHS";
    Type["COMPANY"] = "COMPANY";
})(Type || (Type = {}));
var CurrentSituation;
(function (CurrentSituation) {
    CurrentSituation["CLT"] = "CLT";
    CurrentSituation["INTERNSHIP"] = "INTERNSHIP";
    CurrentSituation["PJ"] = "PJ";
    CurrentSituation["FREELANCER"] = "FREELANCER";
    CurrentSituation["ENTREPRENEUR"] = "ENTREPRENEUR";
    CurrentSituation["SCHOLARSHIP"] = "SCHOLARSHIP";
    CurrentSituation["UNEMPLOYED"] = "UNEMPLOYED";
})(CurrentSituation || (CurrentSituation = {}));
var CurrentJoblevel;
(function (CurrentJoblevel) {
    CurrentJoblevel["INTERNSHIP"] = "INTERNSHIP";
    CurrentJoblevel["TRAINEE"] = "TRAINEE";
    CurrentJoblevel["JUNIOR"] = "JUNIOR";
    CurrentJoblevel["PLENO"] = "PLENO";
    CurrentJoblevel["SENIOR"] = "SENIOR";
    CurrentJoblevel["COORDINATION"] = "COORDINATION";
    CurrentJoblevel["LEAD"] = "LEAD";
})(CurrentJoblevel || (CurrentJoblevel = {}));
var FirstTechJob;
(function (FirstTechJob) {
    FirstTechJob["TO_ONE_MONTHS"] = "TO_ONE_MONTHS";
    FirstTechJob["BETWEEN_ONE_THREE_MONTHS"] = "BETWEEN_ONE_THREE_MONTHS";
    FirstTechJob["BETWEEN_THREE_SIX_MONTHS"] = "BETWEEN_THREE_SIX_MONTHS";
    FirstTechJob["BETWEEN_SEVEN_ONE_YEAR_MONTHS"] = "BETWEEN_SEVEN_ONE_YEAR_MONTHS";
    FirstTechJob["NOT_APPLY"] = "NOT_APPLY";
})(FirstTechJob || (FirstTechJob = {}));
var PlatformCurrentTechJob;
(function (PlatformCurrentTechJob) {
    PlatformCurrentTechJob["PLATAFORMA_REPROGRAMA"] = "PLATAFORMA_REPROGRAMA";
    PlatformCurrentTechJob["LINKEDIN"] = "LINKEDIN";
    PlatformCurrentTechJob["VAGAS"] = "VAGAS";
    PlatformCurrentTechJob["GUPY"] = "GUPY";
    PlatformCurrentTechJob["GREENHOUSE"] = "GREENHOUSE";
    PlatformCurrentTechJob["NINETY_NINE_JOBS"] = "NINETY_NINE_JOBS";
    PlatformCurrentTechJob["COMPLEO"] = "COMPLEO";
    PlatformCurrentTechJob["SAP"] = "SAP";
    PlatformCurrentTechJob["OTHERS"] = "OTHERS";
    PlatformCurrentTechJob["NOT_APPLY"] = "NOT_APPLY";
})(PlatformCurrentTechJob || (PlatformCurrentTechJob = {}));
var NumberSelectionProcesses;
(function (NumberSelectionProcesses) {
    NumberSelectionProcesses["NONE"] = "NONE";
    NumberSelectionProcesses["ONE"] = "ONE";
    NumberSelectionProcesses["TWO"] = "TWO";
    NumberSelectionProcesses["THREE"] = "THREE";
    NumberSelectionProcesses["BIGGER_THAN_THREE"] = "BIGGER_THAN_THREE";
})(NumberSelectionProcesses || (NumberSelectionProcesses = {}));
var JobsSinceGraduation;
(function (JobsSinceGraduation) {
    JobsSinceGraduation["NONE"] = "NONE";
    JobsSinceGraduation["ONE"] = "ONE";
    JobsSinceGraduation["TWO"] = "TWO";
    JobsSinceGraduation["THREE"] = "THREE";
    JobsSinceGraduation["FOUR"] = "FOUR";
    JobsSinceGraduation["FIVE"] = "FIVE";
    JobsSinceGraduation["BIGGER_THAN_FIVE"] = "BIGGER_THAN_FIVE";
})(JobsSinceGraduation || (JobsSinceGraduation = {}));
var DurationEmploymentGraduation;
(function (DurationEmploymentGraduation) {
    DurationEmploymentGraduation["UNEMPLOYED"] = "UNEMPLOYED";
    DurationEmploymentGraduation["LESS_THAN_THREE"] = "LESS_THAN_THREE";
    DurationEmploymentGraduation["THREE_TO_SIX_MONTHS"] = "THREE_TO_SIX_MONTHS";
    DurationEmploymentGraduation["SIX_TO_NINE_MONTHS"] = "SIX_TO_NINE_MONTHS";
    DurationEmploymentGraduation["NINE_TO_TWELVE_MONTHS"] = "NINE_TO_TWELVE_MONTHS";
})(DurationEmploymentGraduation || (DurationEmploymentGraduation = {}));
var ReasonLeavingWork;
(function (ReasonLeavingWork) {
    ReasonLeavingWork["COMPANY_CULTURE"] = "COMPANY_CULTURE";
    ReasonLeavingWork["UNSATISFACTORY_SALARY"] = "UNSATISFACTORY_SALARY";
    ReasonLeavingWork["JOB_NOT_EXPECTED"] = "JOB_NOT_EXPECTED";
    ReasonLeavingWork["BEST_OFFER"] = "BEST_OFFER";
    ReasonLeavingWork["NO_RECOGNITION"] = "NO_RECOGNITION";
    ReasonLeavingWork["TOXIC_LEADERSHIP"] = "TOXIC_LEADERSHIP";
    ReasonLeavingWork["VICTIM_DISCRIMINATION"] = "VICTIM_DISCRIMINATION";
    ReasonLeavingWork["OTHERS"] = "OTHERS";
    ReasonLeavingWork["NOT_APPLY"] = "NOT_APPLY";
})(ReasonLeavingWork || (ReasonLeavingWork = {}));
var CourseLevel;
(function (CourseLevel) {
    CourseLevel["GRADUATE"] = "GRADUATE";
    CourseLevel["TECHNICAL"] = "TECHNICAL";
    CourseLevel["TECHNOLOGIST"] = "TECHNOLOGIST";
    CourseLevel["SPECIALIZATION"] = "SPECIALIZATION";
    CourseLevel["BOOTCAMP"] = "BOOTCAMP";
    CourseLevel["CURSES_ONLINE"] = "CURSES_ONLINE";
})(CourseLevel || (CourseLevel = {}));
var UndertakenArea;
(function (UndertakenArea) {
    UndertakenArea["UNEMPLOYED"] = "UNEMPLOYED";
    UndertakenArea["ENTERPRISING_NOT_TECH"] = "ENTERPRISING_NOT_TECH";
    UndertakenArea["EMPLOYEE_CLT"] = "EMPLOYEE_CLT";
    UndertakenArea["EMPLOYEE_WITHOUT_REGISTRATION"] = "EMPLOYEE_WITHOUT_REGISTRATION";
    UndertakenArea["EMPLOYEE_PJ"] = "EMPLOYEE_PJ";
    UndertakenArea["STUDYING"] = "STUDYING";
})(UndertakenArea || (UndertakenArea = {}));
var CompanySegment;
(function (CompanySegment) {
    CompanySegment["BANK"] = "BANK";
    CompanySegment["RETAIL"] = "RETAIL";
    CompanySegment["INFORMATION_TECHNOLOGY"] = "INFORMATION_TECHNOLOGY";
    CompanySegment["EDUCATION"] = "EDUCATION";
    CompanySegment["OTHER"] = "OTHER";
})(CompanySegment || (CompanySegment = {}));
var TimeEmployed;
(function (TimeEmployed) {
    TimeEmployed["LESS_THREE_MONTHS"] = "LESS_THREE_MONTHS";
    TimeEmployed["BETWEEN_THREE_SIX_MONTHS"] = "BETWEEN_THREE_SIX_MONTHS";
    TimeEmployed["BETWEEN_SIX_NINE_MONTHS"] = "BETWEEN_SIX_NINE_MONTHS";
    TimeEmployed["BETWEEN_NINE_ELEVEN_MONTHS"] = "BETWEEN_NINE_ELEVEN_MONTHS";
    TimeEmployed["ONE_YEAR"] = "ONE_YEAR";
    TimeEmployed["MORE_ONE_YEAR"] = "MORE_ONE_YEAR";
})(TimeEmployed || (TimeEmployed = {}));
var QualityLife;
(function (QualityLife) {
    QualityLife["LIKE_WORK"] = "LIKE_WORK";
    QualityLife["LIVING_CLOSE_WORK"] = "LIVING_CLOSE_WORK";
    QualityLife["SUPPORT_FAMILY"] = "SUPPORT_FAMILY";
    QualityLife["QUALITY_TIME"] = "QUALITY_TIME";
    QualityLife["OTHER"] = "OTHER";
})(QualityLife || (QualityLife = {}));
exports.enums = {
    type: Type,
    educationLevel: ClassVacancySubscription_1.EducationLevel,
    currentSituation: CurrentSituation,
    currentJoblevel: CurrentJoblevel,
    firstTechJob: FirstTechJob,
    platformCurrentTechJob: PlatformCurrentTechJob,
    numberSelectionProcesses: NumberSelectionProcesses,
    jobsSinceGraduation: JobsSinceGraduation,
    durationEmploymentGraduation: DurationEmploymentGraduation,
    reasonLeavingWork: ReasonLeavingWork,
    courseLevel: CourseLevel,
    undertakenArea: UndertakenArea,
    companySegment: CompanySegment,
    timeEmployed: TimeEmployed,
    qualityLife: QualityLife,
};
//# sourceMappingURL=Research.js.map